module.exports = __webpack_public_path__ + "static/media/LeaseZeroMatching.e3d0608f.svg";